/**
 * Plan labels and tier metadata for UI components.
 *
 * For the canonical pricing/feature catalog (with VIP routing,
 * concurrent-slot caps, etc.), call ``GET /api/billing/plans/catalog/``
 * — the backend is the source of truth (``billing/plans.py``).
 *
 * The labels below are user-facing copy and stay frontend-side. If the
 * backend adds a new tier, add a label here too.
 */
export const PLAN_LABELS: Record<string, string> = {
  trial: 'Free',
  free: 'Free',
  starter: 'Starter ($29/mo)',
  growth: 'Growth ($59/mo)',
  professional: 'Pro ($149/mo)',
  scale: 'Scale ($249/mo)',
  enterprise: 'Enterprise ($399/mo)',
};

/**
 * Tier ids that route campaigns to the priority/VIP queue. Mirrors
 * ``billing/plans.py`` ``is_vip``. The frontend uses this only for UI
 * gating (e.g. the "Skip queue" upgrade CTA copy in Phase 3+); routing
 * decisions are made server-side.
 */
export const VIP_TIERS: ReadonlyArray<string> = ['scale', 'enterprise'] as const;

export function isVipTier(tier: string | null | undefined): boolean {
  if (!tier) return false;
  return VIP_TIERS.includes(tier.toLowerCase());
}

export function planLabel(tier: string | null | undefined, fallback = 'Free'): string {
  if (!tier) return fallback;
  return PLAN_LABELS[tier.toLowerCase()] ?? tier ?? fallback;
}
